import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Preferences } from '@capacitor/preferences';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class HttpService {
  isUserAuthorize = false;
  token = null;
  baseUrl = environment.baseUrl;
  user = new BehaviorSubject(null);
  constructor(private http: HttpClient) {}

  doGet(url: string, params?: any) {
    const finalUrl = this.baseUrl + url;
    return this.http.get(finalUrl, {
      headers: {
        authorization: 'bearer ' + this.token,
        params,
      },
    });
  }

  doPost(url: string, body?: Object) {
    const finalUrl = this.baseUrl + url;
    return this.http.post(finalUrl, body, {
      headers: {
        authorization: 'bearer ' + this.token,
      },
    });
  }

  async setToken(token: string) {
    this.token = token;
    await Preferences.set({ key: 'token', value: token });
  }

  getToken() {
    return this.token;
  }

  async getTokenFromStore() {
    const token = await Preferences.get({ key: 'token' });
    return token;
  }

  async clearToken() {
    Preferences.remove({ key: 'token' });
  }
}
